import BenchlingConfig from 'BenchlingConfig';
import {Notation} from 'biojs/BioConstants';
import {NucleotideType, sanitize} from 'biojs/Util';
import {TagSchema} from 'constants/RegistryConstants';
import {TagSchemaSequenceSchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isFullUTFlexibilityEnabled} from 'modbio/util';
import {isDNAOligoSchema, isRNAOligoSchema, isRNASequenceSchema} from 'tag-schema/util/TagSchemaUtil';

export function canSchemaHaveMods(tagSchema: TagSchema): boolean {
  return (
    BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES &&
    (isDNAOligoSchema(tagSchema) || isRNAOligoSchema(tagSchema) || isRNASequenceSchema(tagSchema))
  );
}

export function sanitizeResiduesByNotation(
  residues: string,
  notation: Notation,
  nucleotideType: NucleotideType
): string {
  if (notation === Notation.NATURAL_BASES) {
    return sanitize(residues, nucleotideType, isFullUTFlexibilityEnabled());
  } else {
    return residues;
  }
}

export function sequenceToNucleotideType(
  sequenceType: TagSchemaSequenceSchemaType | null | undefined
): NucleotideType {
  if (sequenceType === TagSchemaSequenceSchemaType.RNA_OLIGO) {
    return NucleotideType.RNA;
  } else {
    return NucleotideType.DNA;
  }
}
